import DeviceComponent from '../components/device/Device';

export default function DeviceList() {
  return (
    <div id={'contents'}>
      <div className={'title'}>
        <p>{'설비 관리'}</p>
      </div>
      <DeviceComponent />
    </div>
  );
}
